import {AutoReordersService} from './auto-reorders.service';
import {EnrollAutoReorderModal} from '../../shared/auto-reorders/EnrollAutoReorderModal/EnrollAutoReorderModal';
import {ImpError} from '../imp-error/imp-error.class';
import {ItemToAdd} from '../../shared/order-items/order-items.class';
import {ProgressOverlay} from '../components/ProgressOverlay';
import {ReactClientService} from '../react/react-client.service';
import {StandardJSONResponse} from '../../shared/tools/AS.types';
import {UpdateAutoRoItemParams} from '../../shared/auto-reorders/AutoReorderClass';
import {UsersService} from '../users/users.service';
import {UserStateService} from '../users/user-state.service';
import {User} from '../../shared/users/user.class';

export class AutoReordersWorkflow {
    private readonly _currentUser: User;
    private readonly _reactClientService: ReactClientService;

    constructor(
        private _autoReordersService: AutoReordersService,
        private _usersService: UsersService,
        private _userStateService: UserStateService,
    ) {
        this._currentUser = this._usersService?.getCurrentUser();
        this._reactClientService = new ReactClientService();
    }

    /**
     * Enrolls provided itemToAdd in auto-reorder
     * @param componentName
     * @param itemToAdd
     */
    public enrollAutoReorder(componentName: string, itemToAdd: ItemToAdd): Promise<StandardJSONResponse> {
        ProgressOverlay.activate();
        return new Promise((resolve, reject) => {
            // Record addToOrder action
            this._userStateService.recordEnrollAutoReorderAction(componentName, itemToAdd);

            // If not logged in, showLoginPopUp
            if (!this._currentUser.isLoggedIn()) {
                this._usersService.showLoginPopUp();
                return;
            }

            // If not activeAccount, present AccountPickerComponent in select mode
            if (!this._currentUser.activeAccount) {
                this._usersService.showAccountPicker(true);
                return;
            }

            // If division level, present AccountPickerComponent in drill mode
            if (this._currentUser.isDivisionLevel()) {
                this._usersService.showAccountPicker(false);
                // Else get updateAutoRoItemParams from user
            } else {
                this._userStateService.clearPendingAction();
                this._showAutoReorderEnrollModal(itemToAdd)
                    .then((updateAutoRoItemParams) => {
                        if (updateAutoRoItemParams) {
                            ProgressOverlay.activate();
                            this._autoReordersService
                                .updateAutoRoItem({
                                    active: true,
                                    intervalNum: parseInt(updateAutoRoItemParams.intervalNum as any),
                                    intervalType: updateAutoRoItemParams.intervalType,
                                    item: updateAutoRoItemParams.item,
                                    startDate: updateAutoRoItemParams.startDate,
                                    status: `save`,
                                    units: parseInt(updateAutoRoItemParams.units as any),
                                })
                                .then((updateAutoRoItemRes) => {
                                    ProgressOverlay.deactivate();
                                    resolve(updateAutoRoItemRes);
                                })
                                .catch((updateAutoRoItemErr: ImpError) => {
                                    ProgressOverlay.deactivate();
                                    reject(updateAutoRoItemErr);
                                });
                        } else {
                            resolve(null);
                        }
                    })
                    .catch((showAutoReorderEnrollModalErr: ImpError) => {
                        ProgressOverlay.deactivate();
                        reject(showAutoReorderEnrollModalErr);
                    });
            }
        });
    }

    /**
     * TBD
     * @param itemToAdd
     * @private
     */
    private _showAutoReorderEnrollModal(itemToAdd: ItemToAdd): Promise<UpdateAutoRoItemParams> {
        return new Promise((resolve, reject) => {
            this._autoReordersService
                .getAutoRoEnrollment(itemToAdd.item, itemToAdd.unitsOrdered)
                .then((getAutoRoEnrollmentRes) => {
                    ProgressOverlay.deactivate();
                    const [root] = this._reactClientService.appendComponent(
                        EnrollAutoReorderModal,
                        {
                            autoRoEnrollment: getAutoRoEnrollmentRes,
                            onHide: () => root.unmount(),
                            onSubmit: (updateAutoRoItemParams) => {
                                root.unmount();
                                resolve(updateAutoRoItemParams);
                            },
                            show: true,
                            user: this._currentUser,
                        },
                        $(`#reactModalElement`)[0],
                    );
                })
                .catch((getAutoRoItemErr: ImpError) => {
                    reject(getAutoRoItemErr);
                });
        });
    }
}
